(function () {
  'use strict';
  // Presentation bridge only: the installed GWP app remains the rewards source.
  if (window.MBIMarket?.ecommerceEnabled !== true) return;
  const sourceSelector = '[data-gwp-root] .gwp-module';
  const hostSelector = '[data-mbi-rewards]';
  const signatures = new WeakMap();
  let source = null;
  let queued = false;
  let drawerCollapsed = false;
  let controlsId = 0;

  function campaignEnabled() {
    try {
      const config = JSON.parse(document.getElementById('gwp-config')?.textContent || '{}');
      return config.enabled === true && config.currency === 'GBP';
    } catch (_error) { return false; }
  }

  function cartHosts() {
    for (const view of document.querySelectorAll('#cart, #mini-cart')) {
      if (view.id === 'mini-cart') {
        const close = view.querySelector('#cart-close');
        if (close?.parentElement) {
          let top = view.querySelector('[data-mbi-rewards="drawer-top"]');
          if (!top) {
            top = document.createElement('div');
            top.dataset.mbiRewards = 'drawer-top';
            top.hidden = true;
          }
          if (top.parentElement !== close.parentElement || top.nextElementSibling !== close) {
            close.insertAdjacentElement('beforebegin', top);
          }
          view.querySelector('[data-mbi-rewards="cart"]')?.remove();
          continue;
        }
      }
      const panel = view.querySelector('[data-mbi-discount-view]');
      const parent = panel?.parentElement;
      if (!parent) continue;
      let host = view.querySelector('[data-mbi-rewards="cart"]');
      if (view.querySelector(sourceSelector)) {
        host?.remove();
        continue;
      }
      if (!host) {
        host = document.createElement('div');
        host.dataset.mbiRewards = 'cart';
        host.hidden = true;
      }
      if (host.parentElement !== parent || host.nextElementSibling !== panel) parent.insertBefore(host, panel);
    }
  }

  function displayModule(original) {
    const module = document.createElement('div');
    module.className = 'gwp-module';
    // Deliberately exclude gift pickers, banners, controls and app event roots.
    for (const selector of ['.gwp-status', '.gwp-progress', '.gwp-legends']) {
      const part = original.querySelector(selector);
      if (!part) return null;
      module.append(part.cloneNode(true));
    }
    module.querySelectorAll('script, style, link, iframe, object, embed, form, input, button, a, select, textarea').forEach(e => e.remove());
    for (const element of module.querySelectorAll('*')) {
      for (const attribute of [...element.attributes]) {
        if (/^on/i.test(attribute.name) || /^(id|tabindex|aria-live|data-sleek-node-id)$/.test(attribute.name)) element.removeAttribute(attribute.name);
      }
    }
    module.querySelector('.gwp-progress').setAttribute('aria-hidden', 'true');
    return module;
  }

  function syncDrawerCollapse() {
    if (!campaignEnabled()) return;
    const selector = '#mini-cart [data-mbi-rewards="drawer-top"] .gwp-module, #mini-cart:not([data-mbi-rewards-at-top]) :is([data-gwp-root], [data-mbi-rewards]) .gwp-module';
    for (const module of document.querySelectorAll(selector)) {
      const status = module.querySelector('.gwp-status');
      const parts = [module.querySelector('.gwp-progress'), module.querySelector('.gwp-legends')];
      if (!status || parts.some(part => !part)) continue;
      module.dataset.mbiRewardsCollapsible = '';
      module.dataset.mbiRewardsCollapsed = String(drawerCollapsed);
      const text = status.textContent.trim();
      if (status.title !== text) status.title = text;
      if (module.closest('[data-mbi-rewards="drawer-top"]')) {
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
      }
      let toggle = module.querySelector(':scope > [data-mbi-rewards-toggle]');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'mbi-rewards-toggle';
        toggle.dataset.mbiRewardsToggle = '';
        module.append(toggle);
      }
      for (const part of parts) {
        if (!part.id) part.id = `mbi-rewards-details-${++controlsId}`;
      }
      toggle.setAttribute('aria-controls', parts.map(part => part.id).join(' '));
      toggle.setAttribute('aria-expanded', String(!drawerCollapsed));
      toggle.setAttribute('aria-label', `${drawerCollapsed ? 'Show' : 'Collapse'} shipping and gift progress`);
      const label = drawerCollapsed ? 'Show' : 'Hide';
      if (toggle.textContent !== label) toggle.textContent = label;
    }
  }

  function sync() {
    queued = false;
    cartHosts();
    const available = [...document.querySelectorAll(sourceSelector)];
    if (!source?.isConnected || !available.includes(source)) source = available[0] || null;
    const module = campaignEnabled() && source ? displayModule(source) : null;
    const signature = module?.outerHTML || '';
    for (const host of document.querySelectorAll(hostSelector)) {
      if (signatures.get(host) !== signature) {
        host.replaceChildren(...(module ? [module.cloneNode(true)] : []));
        signatures.set(host, signature);
      }
      host.hidden = !module;
    }
    const drawer = document.querySelector('#mini-cart');
    const top = drawer?.querySelector('[data-mbi-rewards="drawer-top"]');
    drawer?.toggleAttribute('data-mbi-rewards-at-top', Boolean(top && !top.hidden && top.querySelector('.gwp-module')));
    syncDrawerCollapse();
  }

  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(sync); }
  }

  function init() {
    document.addEventListener('click', event => {
      const toggle = event.target.closest?.('#mini-cart [data-mbi-rewards-toggle]');
      if (!toggle) return;
      event.preventDefault();
      drawerCollapsed = !drawerCollapsed;
      syncDrawerCollapse();
    });
    new MutationObserver(records => {
      let relevant = false;
      for (const record of records) {
        const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (element?.closest(hostSelector)) continue;
        const changed = element?.closest('[data-gwp-root]')?.querySelector('.gwp-module');
        if (changed) source = changed;
        for (const node of record.addedNodes || []) {
          if (node.nodeType !== 1 || node.closest(hostSelector)) continue;
          const added = node.matches(sourceSelector) ? node : node.querySelector(sourceSelector);
          if (added) source = added;
        }
        if (record.type === 'childList' || changed || element?.id === 'gwp-config') relevant = true;
      }
      if (relevant) schedule();
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    document.addEventListener('mbi:cart-rendered', schedule);
    document.addEventListener('gwp:cart-changed', schedule);
    window.addEventListener('pageshow', schedule);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
